import React, { useContext } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { EmptyObject } from '../../react-app-env';
import { Sidebar, Topbar } from './components';
import { Breadcrum } from './components/Topbar';

import { Paper, withStyles } from '@material-ui/core';

import {
  HomeOutlined as HomeIcon,
  Home as HomeActiveIcon,
  HomeWorkOutlined as OrganisationIcon,
  HomeWork as OrganisationActiveIcon,
  StoreMallDirectoryOutlined as LocationIcon,
  StoreMallDirectory as LocationActiveIcon,
  GroupAddOutlined as UesrsIcon,
  GroupAdd as UesrsActiveIcon,
  MenuBookOutlined as MenuIcon,
  MenuBook as MenuActiveIcon,
  ListAltOutlined as ReportsActiveIcon,
  ListAlt as ReportsIcon,
  ReorderOutlined as AccountsIcon,
  Reorder as AccountsActiveIcon,
  PlaylistAddCheckOutlined as ReferralsIcon,
  PlaylistAddCheck as ReferralsActiveIcon,
  TuneOutlined as SettingsIcon,
  Tune as SettingsActiveIcon,
  PrintOutlined as PrinterIcon,
  Print as PrinterActiveIcon,
  LocalOfferOutlined as VoucherIcon,
  LocalOffer as VoucherActiveIcon,
  PeopleOutlineOutlined as StaffIcon,
  PeopleOutline as StaffActiveIcon,
  DevicesOtherOutlined as DeviceIcon,
  DevicesOther as DeviceActiveIcon,
  SettingsInputComponentOutlined as IntegrationsIcon,
  SettingsInputComponent as IntegrationsActiveIcon,
  StorefrontOutlined as StockIcon,
  Storefront as StockActiveIcon,
  ScheduleOutlined as AvailabilityIcon,
  Schedule as AvailabilityActiveIcon,
} from '@material-ui/icons';

import { AuthContext } from '../../components/AuthProvider';
import { ListItemRoles } from './components/Sidebar/components/SidebarItemsList';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, React.PropsWithChildren<EmptyObject> {
  classes: ClassNameMap<string>;
  title?: string;
  breadcrumbs?: Breadcrum[];
}

const NAV_ITEMS: ListItemRoles = {
  admin: {
    key: 'admin',
    title: 'Admin',
    sections: [
      {
        items: [{ label: 'Home', icon: <HomeIcon />, iconActive: <HomeActiveIcon />, to: '/admin/home' }],
      },
      {
        sectionLabel: 'Management',
        items: [
          { label: 'Organisations', icon: <OrganisationIcon />, iconActive: <OrganisationActiveIcon />, to: '/admin/organisations' },
          { label: 'Admin Users', icon: <UesrsIcon />, iconActive: <UesrsActiveIcon />, to: '/admin/users' },
        ],
      },
      {
        sectionLabel: 'System',
        items: [
          { label: 'Referrals', icon: <ReferralsIcon />, iconActive: <ReferralsActiveIcon />, to: '/admin/referrals' },
          { label: 'Device Apps', icon: <DeviceIcon />, iconActive: <DeviceActiveIcon />, to: '/admin/organisations/device-apps' },
        ],
      },
    ],
  },
  owner: {
    key: 'org',
    title: 'Organisation',
    sections: [
      {
        items: [{ label: 'Home', icon: <HomeIcon />, iconActive: <HomeActiveIcon />, to: '/org/home' }],
      },
      {
        sectionLabel: 'Operations',
        items: [{ label: 'Menus', icon: <MenuIcon />, iconActive: <MenuActiveIcon />, to: '/org/menus' }],
      },
      {
        sectionLabel: 'Management',
        items: [
          { label: 'Locations', icon: <LocationIcon />, iconActive: <LocationActiveIcon />, to: '/org/locations' },
          { label: 'Users', icon: <UesrsIcon />, iconActive: <UesrsActiveIcon />, to: '/org/users' },
        ],
      },
      {
        sectionLabel: 'Analytics',
        items: [{ label: 'Reports', icon: <ReportsIcon />, iconActive: <ReportsActiveIcon />, to: '/org/reports' }],
      },
    ],
  },
  manager: {
    key: 'loc',
    title: 'Location',
    sections: [
      {
        items: [{ label: 'Home', icon: <HomeIcon />, iconActive: <HomeActiveIcon />, to: '/loc/home' }],
      },
      {
        sectionLabel: 'Operations',
        items: [
          { label: 'Sales', icon: <AccountsIcon />, iconActive: <AccountsActiveIcon />, to: '/loc/sales' },
          { label: 'Menus', icon: <MenuIcon />, iconActive: <MenuActiveIcon />, to: '/loc/menus' },
          { label: 'Stock Management', icon: <StockIcon />, iconActive: <StockActiveIcon />, to: '/loc/stock' },
          { label: 'Availability', icon: <AvailabilityIcon />, iconActive: <AvailabilityActiveIcon />, to: '/loc/availability' },
        ],
      },
      {
        sectionLabel: 'People',
        items: [
          { label: 'Users', icon: <UesrsIcon />, iconActive: <UesrsActiveIcon />, to: '/loc/users' },
          { label: 'Staff', icon: <StaffIcon />, iconActive: <StaffActiveIcon />, to: '/loc/staff' },
        ],
      },
      {
        sectionLabel: 'Analytics',
        items: [{ label: 'Reports', icon: <ReportsIcon />, iconActive: <ReportsActiveIcon />, to: '/loc/reports' }],
      },
      {
        sectionLabel: 'Configuration',
        items: [
          { label: 'Printers', icon: <PrinterIcon />, iconActive: <PrinterActiveIcon />, to: '/loc/printers' },
          { label: 'Vouchers', icon: <VoucherIcon />, iconActive: <VoucherActiveIcon />, to: '/loc/vouchers' },
          { label: 'Integrations', icon: <IntegrationsIcon />, iconActive: <IntegrationsActiveIcon />, to: '/loc/integrations' },
          { label: 'Settings', icon: <SettingsIcon />, iconActive: <SettingsActiveIcon />, to: '/loc/settings' },
        ],
      },
    ],
  },
};

const Dashboard = ({ classes, title, breadcrumbs, children }: Props): React.ReactElement => {
  const { user, userRole, signOut } = useContext(AuthContext)!;

  return (
    <>
      <div className={classes.root}>
        <Sidebar userRole={userRole as string} signOut={signOut} listItemRoles={NAV_ITEMS} />
        <Paper elevation={0} className={classes.main}>
          <Topbar title={title} user={{ ...user }} breadcrumbs={breadcrumbs} />
          <main className={classes.content}>
            <div className={classes.contentContainer}>{children}</div>
          </main>
        </Paper>
      </div>
    </>
  );
};

export default withStyles(styles)(Dashboard);
